<template>
    <v-dialog v-model="error_open" :width="520" dark>
        <v-card>
            <v-card-title class="headline inverted--text">{{ error_options.title }}</v-card-title>
            <v-card-text class="inverted--text">{{ error_options.text }}</v-card-text>
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn color="primary inverted--text" @click="closeError()">
                    {{ $t("Close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed } from "@vue/composition-api";
import DialogModule from "../../store/modules/dialog";

export default {
    name: "ErrorDialog",
    setup() {
        const { error_options, error_open, setError, closeError } = DialogModule();
        const dialog_state = computed({
            get: () => error_open.value,
            set: val => {
                setError(val);
            }
        });
        const confirm = function() {
            error_options.value.action();
            closeError();
        };
        return {
            dialog_state,
            error_options,
            confirm,
            closeError,
            error_open
        };
    }
};
</script>
